<!--详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             :style="{background:backimg}" class="print-table">
        <tr class="noborder">
          <td align="left" style="width: 90px;">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            <el-select v-model="cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="left" style="width: 90px;">加工师：</td>
          <td>
            <CommonTree ref="treeDserial" :treeHeight="180" :searchText="jiagonguname" @check="changeServer"
                        placeholder="请选择"
                        style="width: 150px"
                        :isShowCheckBox="false"></CommonTree>
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr>
          <td colspan="4" style="border:none">
            <el-input placeholder="请输入关联订单号" v-model="searchdata" size="small" clearable
                      @keyup.enter.native="searchOrder" @clear="searchOrder" v-if="showDD" style="width: 200px;margin-left: 85px">
              <el-button slot="append" type="primary" icon="el-icon-search" @click="searchOrder" size="small"></el-button>
            </el-input>
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td v-if="item !='seedcode'&&item != 'packagesize'&&item != 'subseedcode'&&item != 'formproperty'&&item != '关联产品'&&item !='unitguid'&&item !='单价'&&item !='总价'&&item !='订单状态'"
                    style="text-align: center;"
                    v-for="item in column">
                  {{item}}
                </td>
                <td style="text-align: center;">选择</td>
              </tr>
              <tr v-for="item in tableData">
                <td
                  :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                  v-for="(ob,index) in item"
                  v-if="index!=0&&index!=item.length-2&&index!=item.length-3&&index!=item.length-4&&typeof(ob['subseedcode'])=='undefined'&&typeof(ob['formproperty'])=='undefined'&&typeof(ob['关联产品'])=='undefined'&&typeof(ob['packagesize'])=='undefined'&&typeof(ob['unitguid'])=='undefined'&&index!=item.length-1">
                  <span v-for="value in ob" v-if="!ob['数量']">{{value}}</span>
                  <input type="text" v-if="typeof(ob['数量'])!='undefined'" v-model="ob['数量']" style="width: 60px"/>
                  <div v-if="ob['产品名称']" v-html="getGuanLGoods(item)"></div>
                </td>
                <td style="text-align: center;" v-for="(ob,index) in item" v-if="index==item.length-1">
                  <el-checkbox v-model="ob.checked"></el-checkbox>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 20px"></tr>
        <tr class="noborder">
          <td align="left" style="width: 10px;">报损原因：</td>
          <td colspan="3" style="border: none;height: 30px">
            <el-radio v-model="baoSunType" label="2">质量问题</el-radio>
            <el-radio v-model="baoSunType" label="1">加工损坏</el-radio>
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10}"
              placeholder="请输入报损原因"
              v-model="remark">
            </el-input>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogMachiningVisible = false;">取 消</el-button>
      <el-button type="primary" @click="baosun" :loading="loading">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {glassesArrival,machiningOrder} from '@/api/set/csagreement';
  import {machiningBaosun} from '@/api/set/jxcstoreform';
  import {getRemark} from '@/plugin/ordercommon'
  import {cusandptbyind} from '@/api/set/jxcstore';

  export default {
    name: 'CstagreementMachiningBaosun',
    data() {
      return {
        loading:false,
        baoSunType:'1',
        searchdata:'',
        showDD:false,
        jiagonguname:'',
        jiagonguguid:'',
        backimg: '',
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        tableData: [],
        column: [],
        handlelogData: [],//处理日期
        remark: '',
        jxcstoreData: [],//仓库信息
        cangkucode: '',//仓库编码
        cangkuname: '',//仓库名称
        erpserial: '',
      }
    },
    methods: {
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      getGuanLGoods(rows) {
        var goods = this.getMapValue(rows, '关联产品');
        if (goods) {
          return '<div style="float: left;padding-left: 20px">' + goods + '</div>'
        }
        return '';
      },
      changeServer(guids, names, arr){
        this.jiagonguguid = guids;
        this.jiagonguname = names;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      //报损
      baosun() {
        this.loading=true;

        if(this.cangkucode==''){
          this.$message({message: '仓库必选！',type: 'error'})
          this.loading=false;
          return;
        }
        if(this.jiagonguguid==''){
          this.$message({message: '加工师必选！',type: 'error'})
          this.loading=false;
          return;
        }
        if(this.remark==''){
          this.$message({message: '报损原因必填！',type: 'error'})
          this.loading=false;
          return;
        }

        var hasData=false;
        for (let i in this.tableData) {
          var haNum=false;
          for (let j in this.tableData[i]) {

            if (this.tableData[i][j].checked) {
                hasData = true;
            }

            if (this.tableData[i][j]["数量"]) {
              var num=parseInt(this.tableData[i][j]["数量"])
              if (!num||num <= 0) {
                this.$message({message: '数量格式不正确！',type: 'error'})
                this.loading=false;
                return;
              }
              this.tableData[i][j]["数量"]=num;
              haNum=true;
            }
          }
          if(!haNum){
            this.$message({message: '数量格式不正确！',type: 'error'})
            this.loading=false;
            return;
          }
        }
        if(!hasData){
          this.$message({message: '至少选择一条报损明细！',type: 'error'})
          this.loading=false;
          return;
        }

        machiningBaosun({
          tableData: JSON.stringify(this.tableData),
          cangkuname: this.cangkuname,
          cangkucode: this.cangkucode,
          jiagonguguid: this.jiagonguguid,
          jiagonguname: this.jiagonguname,
          erpserial: this.erpserial,
          baosuntype: this.baoSunType,
          remark: this.remark
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$emit("bindGrid");
            this.dialogMachiningVisible = false
          }else{
            this.loading=false;
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "报损单"
        return result
      },
      show(controlData, column, tableData) {
        this.remark=''
        this.loading=false
        this.baoSunType="1"
        this.column = column
        this.erpserial = controlData.erpserial
        this.jiagonguguid=""
        this.jiagonguname=""
        this.searchdata=""
        this.showDD=true;
        this.tableData = JSON.parse(JSON.stringify(tableData))
        for (let i in this.tableData) {
          var obj = {}
          obj['checked'] = false
          this.tableData[i].push(obj)
          this.showDD=false;
        }
        this.dialogMachiningVisible = true;
      },contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },searchOrder(){
        this.tableData=[];
        if(this.searchdata==""&&this.searchdata.length!=14){
          return;
        }
        machiningOrder({
          unitguid: this.searchdata,
          groupguid: "onlydetail"
        }).then(response => {
          this.tableData = response.data.obj.goodsDetail;

          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0
            for (let i in this.tableData) {
              if (this.tableData[i]["订单状态"] != "已发货") {
                this.count++
              }
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j != "seedcode"&& j != "R/L" && j != "数量" && j != "订单状态" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "单价" && j != "总价") {
                  temparr.push(j)
                }
              }
            }
            this.column=[]
            //对表头排序
            this.column.push("seedcode")
            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("产品名称")
            this.column.push("球镜")
            this.column.push("柱镜")
            this.column.push("轴位")
            this.column = this.column.concat(temparr)
            this.column.push("数量")
            this.column.push("订单状态")
            this.column.push("单价")
            this.column.push("总价")
            //this.column.push("说明")

            this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
              let ob = {}
              ob[o2] = o1[o2]
              return ob
            }))
          }
          for (let i in this.tableData) {
            var obj = {}
            obj['checked'] = false
            this.tableData[i].push(obj)
          }
        });
      },
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.cangkucode = this.jxcstoreData[0].cangkucode
          this.cangkuname = this.jxcstoreData[0].cangkuname
        }
      })
    },
    components: {
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementMachiningBaosun.vue